import React, { ChangeEventHandler, useEffect, useState } from "react";
import MainLayout from "../../layouts/main_layout/main_layout";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { Close, Download, Remove } from "@mui/icons-material";
import { addDoc, collection, query } from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { useFeedback } from "../../providers/feedback/feedback";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import {
  deaneryList,
  parishListMap,
  type DeaneryOption as Deanery,
  type ParishOption as Parish,
} from "../../utils/deanery_parishes";
import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { storage } from "../..";
import { ref } from "firebase/storage";

const heirarcyList: { id: number; name: string }[] = [
  { id: 2, name: "Parish" },
  { id: 1, name: "Deanery" },
];

const trainingList: { id: number; name: string }[] = [
  { id: 2, name: "Youcat" },
  { id: 1, name: "Pro" },
  { id: 3, name: "Animator" },
];

function ProAndYoucatTraining() {
  const { showSnackbar } = useFeedback();
  const navigate = useNavigate();
  const firestore = useFirestore();
  const [parishList, setParishList] = useState<Parish[]>([]);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [_selectedDeanery, _setSelectedDeanery] = useState<{
    id: Number;
    name: string;
  } | null>(null);
  const [_selectedParish, _setSelectedParish] = useState<{
    id: Number;
    value: string;
  } | null>(null);
  const [RepresentativeFrom, setRepresentativeFrom] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [participatingFrom, setParticipatingFrom] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [reciept, setReciept] = useState<File | null>(null);
  const [participateName, setParticipateName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const collectionDataForTraining = collection(firestore, "proYoucatTraining");
  const chapterCollectionQueryForTraining = query(collectionDataForTraining);

  const { data: registrationList } = useFirestoreCollectionData(
    chapterCollectionQueryForTraining
  );

  async function submit() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let hasAlreadyRegistered = registrationList?.filter(
      (item) => item?.contactNumber === contactNumber || item?.email === email
    );

    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
    } else if (hasAlreadyRegistered?.length) {
      showSnackbar("You have already registered.!!", "#f44336");
    } else {
      setIsLoading(true);
      const storageRef = ref(storage, `proTraining/${reciept?.name}`);
      const usersCollection = collection(firestore, "proYoucatTraining");
      const uploadTaskForTuhumbail = uploadBytesResumable(storageRef, reciept!);
      await uploadTaskForTuhumbail;
      const downloadURL = await getDownloadURL(storageRef);

      addDoc(usersCollection, {
        createdAt: Date().toString(),
        updatedAt: Date().toString(),
        deaneryName: _selectedDeanery,
        parishName: _selectedParish,
        email: email,
        fullName: participateName,
        trainingProgram: participatingFrom,
        RepresentativeFrom: RepresentativeFrom,
        contactNumber: contactNumber,
        reciept: downloadURL,
      })
        .then((res) => {
          setIsLoading(false);
          showSnackbar("Registration successful!");
          navigate("/");
        })
        .catch((e) => {
          showSnackbar("Something went wrong. Please try again later.");
          setIsLoading(false);
        });
    }
  }

  const handleDeaneryChange = (
    event: React.SyntheticEvent<Element, Event>,
    value: Deanery | null
  ) => {
    if (value) {
      _setSelectedDeanery({ id: value.id, name: value.name });
      setParishList(parishListMap[value.name] || []);
      _setSelectedParish(null);
    } else {
      _setSelectedDeanery(null);
      setParishList([]);
    }
  };

  return (
    <MainLayout>
      <Box my={4}>
        <Box>
          <Typography
            fontWeight={500}
            textAlign={"center"}
            variant={isMobile ? "h6" : "h4"}
          >
            Youcat, PRO and Animator Training - 2026
          </Typography>
          <Typography
            fontWeight={500}
            textAlign={"center"}
            variant={isMobile ? "subtitle1" : "h6"}
          >
            Registration Form
          </Typography>
        </Box>
        <Box mt={3}>
          <Grid container spacing={3}>
            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
              <Box display={"flex"} flexDirection={"column"}>
                <Typography variant="caption" fontWeight={600}>
                  Note: For any modifications or clarifications regarding your
                  registration, please reach out to :
                </Typography>
                <Typography variant="caption" fontWeight={600}>
                  Fr.Steevan Fernandes -9945733168, Alson Mathias - 8861279454
                </Typography>

                <Box display={"flex"} flexDirection={"column"}>
                  <Typography variant="caption" fontWeight={600} mt={2}>
                    Registration Fee: ₹200 per person.
                  </Typography>

                  <Box>
                    <Typography variant="caption" fontWeight={600}>
                      Download QR code
                    </Typography>
                    <a target="_blank" href="/images/scanner.jpeg" download>
                      <IconButton>
                        <Download />
                      </IconButton>
                    </a>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Full Name <span style={{ color: "red" }}>*</span>:
                </Typography>
                <TextField
                  fullWidth
                  value={participateName}
                  onChange={(e) => setParticipateName(e.target.value)}
                />
              </Box>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Training Program <span style={{ color: "red" }}>*</span>:
                </Typography>
                <Autocomplete
                  fullWidth
                  value={
                    trainingList.find(
                      (option) => participatingFrom?.id === option.id
                    ) || null
                  }
                  onChange={(e, val) => {
                    setParticipatingFrom({ id: +val?.id!, name: val?.name! });
                  }}
                  options={trainingList}
                  getOptionLabel={(option) => option.name || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Representative From<span style={{ color: "red" }}>*</span>:
                </Typography>
                <Autocomplete
                  fullWidth
                  value={
                    heirarcyList.find(
                      (option) => RepresentativeFrom?.id === option.id
                    ) || null
                  }
                  onChange={(e, val) => {
                    setRepresentativeFrom({ id: +val?.id!, name: val?.name! });
                  }}
                  options={heirarcyList}
                  getOptionLabel={(option) => option.name || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Deanery name <span style={{ color: "red" }}>*</span>:
                </Typography>
                <Autocomplete
                  fullWidth
                  value={
                    deaneryList.find(
                      (option) => _selectedDeanery?.id === option.id
                    ) || null
                  }
                  onChange={handleDeaneryChange}
                  options={deaneryList}
                  getOptionLabel={(option) => option.name || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </Box>
            </Grid>
            {/* <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid> */}
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Parish name <span style={{ color: "red" }}>*</span>:
                </Typography>
                <Autocomplete
                  fullWidth
                  value={
                    parishList.find(
                      (option: Parish) => _selectedParish?.id === option.id
                    ) || null
                  }
                  onChange={(e: React.SyntheticEvent, value: Parish | null) =>
                    _setSelectedParish(value)
                  }
                  options={parishList}
                  getOptionLabel={(option: Parish) => option.value || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                  disabled={!parishList.length}
                />
              </Box>
            </Grid>

            {/*              
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid> */}
            <Grid item xl={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Email <span style={{ color: "red" }}>*</span>:
                </Typography>
                <TextField
                  fullWidth
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError("");
                  }}
                  helperText={error}
                  FormHelperTextProps={{
                    sx: { color: "red" }, // Set helperText color to red
                  }}
                />
              </Box>
            </Grid>
            <Grid item xl={4} md={4} sm={12} xs={12}>
              <Box>
                <Typography mb={1} fontWeight={500}>
                  Contact number <span style={{ color: "red" }}>*</span>:
                </Typography>
                <TextField
                  fullWidth
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                  }}
                  value={contactNumber}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/\D/g, "");
                    setContactNumber(inputValue);
                  }}
                />
              </Box>
            </Grid>
            <Grid item xl={4} md={4} sm={12} xs={12}>
              <Typography mb={1} fontWeight={500}>
                Payment Reciept
                <span style={{ color: "red" }}>*</span>:
              </Typography>
              {!reciept ? (
                <TextField
                  fullWidth
                  type="file"
                  value={reciept}
                  onChange={(e) => {
                    const fileInput = e.target as HTMLInputElement;

                    if (fileInput.files && fileInput.files[0]) {
                      const allowedTypes = ["jpeg", "jpg", "png"]; // Allowed MIME types
                      if (
                        allowedTypes.includes(
                          fileInput?.files?.[0]?.name
                            .split(".")
                            ?.pop()
                            ?.toLowerCase()!
                        )
                      ) {
                        setReciept(fileInput.files[0]);
                      } else {
                        e.target.value = "";
                        showSnackbar("Please select a valid image file");
                      }
                    }
                  }}
                  helperText={error}
                  FormHelperTextProps={{
                    sx: { color: "red" },
                  }}
                  inputProps={{
                    accept: "image/*",
                  }}
                />
              ) : (
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                >
                  <Typography variant="body1" fontWeight={600}>
                    {reciept?.name}
                  </Typography>
                  <Box display={"flex"} ml={1}>
                    <IconButton
                      size={"small"}
                      onClick={() => {
                        setReciept(null);
                      }}
                      style={{ color: "#000000" }}
                    >
                      <Close />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
        <Grid container>
          <Grid lg={10} xl={10} md={10} sm={12} xs={12}>
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              mt={5}
            >
              <Button
                sx={{
                  width: "fit-content",
                  minWidth: 300,
                  justifyContent: "center",
                }}
                variant="contained"
                onClick={submit}
                disabled={
                  !_selectedParish?.id ||
                  !participatingFrom ||
                  !RepresentativeFrom ||
                  !email ||
                  !_selectedDeanery ||
                  !reciept ||
                  !participateName ||
                  contactNumber.length != 10 ||
                  isLoading
                }
              >
                {isLoading ? (
                  <Box
                    display="flex"
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <CircularProgress size={30} />
                  </Box>
                ) : (
                  <Typography fontWeight={500}>Register</Typography>
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </MainLayout>
  );
}
export default ProAndYoucatTraining;
